import styled from 'styled-components';
import { device, getWidthRange } from '../../../utils/responsive_utilities';

export const ReviewContainer = styled.div`
  font-family: Graphie;
  font-style: normal;
  width: 36.8rem;
  background-color: #EDEDF9;
  overflow-y: auto;
  @media ${device.Phone}, ${device.PhoneLargeScreen}, ${device.Tablet}, ${device.TabletLandscape} {
    display: none;
  }
  @media ${device.PhoneLargeScreen} {
    display: none;
  }

`
export const Reviews = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 7.8rem);
`;

export const Review = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2.5rem 4.2rem;
  color: #EDEDF9;
`

export const LogoImage = styled.div`
  width: 19.1rem;
  height: 3.6rem;
  margin: 4.2rem 0 0 4.2rem;
  flex-basis: 5%;

  img{
    width: 100%;
    height:100%;
    margin-top: 0.4rem;
  }
`

export const Title = styled.div`
  color: #141953;
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 1.9rem;
`;


export const Grade = styled.p`
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.2rem;
  color: #141975;
  margin-top: 0.4rem;
`;

export const Name = styled.p`
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.4rem;
  color: #141975;
`;

export const ImageWrapper = styled.div`
  width: 5.5rem;
  position: relative;
  img{
    width: 5.5rem;
    height: 5.5rem;
    border-radius: 50%;
  }
`

export const ParentInfoWrap = styled.div`
  width: calc(100% - 6.3rem);
`

export const ExtraInfoWrapper = styled.div`
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
`

export const ExtraInfoContent = styled.div`
  margin: auto;
`

export const RatingImagWrapper = styled.div`
  width: 6.5rem;
  height: 1.07rem;
  margin: auto 0;
  img{
    width: 100%;
    height: 100%;
    margin-top: 0.4rem;
  }
`
